export const signIn = async () => {
	try {
		const csrfTokenPath = `/api/auth/csrf`;
		const loginUrl = '/api/auth/signin/keycloak';
		const csrfTokenResponse = await fetch(csrfTokenPath);
		const { csrfToken } = await csrfTokenResponse.json();
		const callbackUrl = window.location.href;
		const res = await fetch(loginUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'X-Auth-Return-Redirect': '1',
			},
			body: new URLSearchParams({
				csrfToken,
				callbackUrl,
			}),
		});

		const data = await res.clone().json();

		window.location.href = data.url ?? callbackUrl;
	} catch (_) {
		throw new Error('Failed to redirect to login');
	}
};
